import { BaseContext } from '../../../utils/basecontext';
import { HttpClient } from '../../../utils/httpclient/httpclient';
import { GET } from '../api';
import { SixdeeCRBTAPI } from '../sixdeecrbtapi';
import { PackStatusRequest } from './packstatusrequest';
import { LanguageConst } from '../../../utils/resources/languageconst';

export class PackStatusAPI extends SixdeeCRBTAPI<PackStatusRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return GET;
    }

    getAPIURL(): string
    {
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/pack-status
        return "pack-status"+"?"+"msisdn=" + this.getRequest().getPackStatusRequest().getMsisdn()+"&"+
               "language="+ (this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ? "1": "2");
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/packstatus/packstatusapi.tsx